import React, {useState, forwardRef, useImperativeHandle, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Modal, Divider, Image, Row, Col, Avatar, Spin, Card, Tabs, Tag, Table} from 'antd';
import _ from 'lodash';
import ReactPlayer from 'react-player';
import styles from './msg.detail.modal.module.less';
import {getFileUrl} from '@/page/util/appUrlUtils';
import {groupMessageDetail, sendMsgResult} from '@/api/customer';
import {UserDeleteOutlined, UserOutlined} from '@/icons';

const {TabPane} = Tabs;

const MsgDetailModal = forwardRef(({msgId, sendType, userId}, ref) => {
    useImperativeHandle(ref, () => ({
        open,
    }));
    const [now, setNow] = useState(null);

    useEffect(() => {
        !_.isEmpty(msgId) && init();
    }, [msgId, now]);
    const [visible, setVisible] = useState(false);
    const [msgInfo, setMsgInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const [sendResult, setSendResult] = useState([]);
    const [sender, setSender] = useState(null);
    const columns = [
        {
            title: '客户名称',
            dataIndex: 'externalUserName',
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: status => switchTag(status),
        },
    ];

    function switchTag(status) {
        status = parseInt(status, 10);
        let temp;
        // 0-未发送 1-已发送 2-因客户不是好友导致发送失败 3-因客户已经收到其他群发消息导致发送失败
        switch (status) {
            case 0:
                temp = <Tag color="red">未发送</Tag>;
                break;
            case 1:
                temp = <Tag color="green">已发送</Tag>;
                break;
            case 2:
                temp = <Tag color="cyan">因客户不是好友导致发送失败</Tag>;
                break;
            case 3:
                temp = <Tag color="magenta">因客户已经收到其他群发消息导致发送失败</Tag>;
                break;
        }
        return temp;
    }

    function init() {
        setLoading(true);
        groupMessageDetail(msgId, sendType, userId).then(res => {
            setMsgInfo(res.data);
            getSendResult(res.data);
        });
    }

    function getSendResult(result) {
        let userId;
        userId = sendType === 'singleCustomer' ? result.sysUsers[0].extId : sender;
        sendMsgResult(result.msgId, userId).then(res => {
            setSendResult(res.data);
            setLoading(false);
        });
    }

    function handleCancel() {
        setMsgInfo({});
        setVisible(false);
    }

    function open(sender) {
        setSender(sender);
        setNow(new Date());
        setVisible(true);
    }

    function renderTitle() {
        if (!_.isEmpty(msgInfo)) {
            return <p>{sendType === 'singleCustomer' ? '群发消息' : msgInfo.name + '群发消息'}</p>;
        }
    }

    function renderLink() {
        const {urls} = msgInfo;
        return (
            !_.isEmpty(urls) &&
            urls.length > 0 && (
                <>
                    <p className={styles.value}>链接</p>
                    <Row gutter={10}>
                        {urls.map((item, i) => (
                            <div key={i} className={styles.content}>
                                {item.title || '暂无链接名称'}{' '}
                                <a href={item.url || ''} target="_blank">
                                    ({item.url || '暂无链接地址'})
                                </a>
                            </div>
                        ))}
                        <Divider />
                    </Row>
                </>
            )
        );
    }

    function renderContent() {
        const {content} = msgInfo;
        return (
            <>
                <p className={styles.value}>内容</p>
                <div className={styles.content}>{content}</div>
                <Divider />
            </>
        );
    }

    function changeResultTab(e) {
        sendMsgResult(msgInfo.msgId, e).then(res => {
            setSendResult(res.data);
        });
    }

    function renderMedia(type = 0) {
        const {images, videos, files} = msgInfo;
        if (type === 0) {
            return (
                !_.isEmpty(images) &&
                images.length > 0 && (
                    <>
                        <p className={styles.value}>图片</p>
                        <Row gutter={10}>
                            <Image.PreviewGroup>
                                {images.map((sysAttache, key) => (
                                    <Col span={8}>
                                        <Image
                                            src={getFileUrl(sysAttache.id, sysAttache.fileExt)}
                                            key={key}
                                            width={200}
                                            height={100}
                                            style={{objectFit: 'cover', marginLeft: '10px'}}
                                        />
                                    </Col>
                                ))}
                            </Image.PreviewGroup>
                        </Row>
                        <Divider />
                    </>
                )
            );
        } else if (type === 1) {
            return (
                !_.isEmpty(videos) &&
                videos.length > 0 &&
                videos.map((sysAttache, key) => (
                    <>
                        <p className={styles.value}>视频</p>
                        <ReactPlayer
                            style={{marginLeft: '10px'}}
                            width={200}
                            height={100}
                            controls
                            key={key}
                            playing={false}
                            url={getFileUrl(sysAttache.id, sysAttache.fileExt)}
                        />
                        <Divider />
                    </>
                ))
            );
        } else if (type === 2) {
            return (
                !_.isEmpty(files) &&
                files.length > 0 && (
                    <>
                        <p className={styles.value}>文件</p>
                        {files.map((sysAttache, key) => (
                            <div style={{marginLeft: '20px'}}>
                                <a
                                    href={getFileUrl(sysAttache.id, sysAttache.fileExt)}
                                    target="_blank"
                                    key={key}
                                >
                                    {sysAttache.fileName}
                                </a>
                            </div>
                        ))}
                        <Divider />
                    </>
                )
            );
        } else {
            return '';
        }
    }

    function renderSendResult() {
        console.log('res...', msgInfo, sendType, sendResult);
        return (
            <div className={styles.task}>
                <p className={styles.label}>发送结果：</p>
                {sendType === 'singleCustomer' && (
                    <Tabs
                        tabPosition="left"
                        onChange={changeResultTab}
                        defaultActiveKey={msgInfo.sysUsers[0].extId}
                    >
                        {msgInfo.sysUsers.map((sysUser, i) => (
                            <TabPane tab={sysUser.name} key={sysUser.extId}>
                                <Table
                                    key={i}
                                    columns={columns}
                                    dataSource={sendResult}
                                    rowKey={record => record.externalUserId}
                                    loading={loading}
                                />
                            </TabPane>
                        ))}
                    </Tabs>
                )}
                {sendType === 'singleSender' && (
                    <Table
                        columns={columns}
                        dataSource={sendResult}
                        rowKey={record => record.externalUserId}
                        loading={loading}
                    />
                )}
                {sendType === 'group' && sendResult.length > 0 && (
                    <Tag color="green">已发送{sendResult.length}个群</Tag>
                )}
                {sendType === 'group' && sendResult.length == 0 && <Tag color="red">未发送</Tag>}
                <Divider />
            </div>
        );
    }

    return (
        <Modal
            width={'70%'}
            title={renderTitle()}
            visible={visible}
            onCancel={handleCancel}
            footer={null}
            destroyOnClose={true}
        >
            <Spin spinning={loading}>
                <div className={styles.modalContent}>
                    <div className={styles.left}>
                        <div className={styles.label}>消息类型：</div>
                        <div className={styles.value}>
                            {sendType === 'singleCustomer' && '个人群发'}
                            {sendType === 'singleSender' && '企业群发-发送人'}
                            {sendType === 'group' && '企业群发-发送群'}
                        </div>
                        <div className={styles.label}>消息详情：</div>
                        {!_.isEmpty(msgInfo) && renderContent()}
                        {!_.isEmpty(msgInfo) && renderLink()}
                        {!_.isEmpty(msgInfo) && renderMedia()}
                        {!_.isEmpty(msgInfo) && renderMedia(1)}
                        {!_.isEmpty(msgInfo) && renderMedia(2)}
                    </div>
                    <div className={styles.right}>{!_.isEmpty(msgInfo) && renderSendResult()}</div>
                </div>
            </Spin>
        </Modal>
    );
});

MsgDetailModal.displayName = 'MsgDetailModal';

MsgDetailModal.propTypes = {
    momentInfo: PropTypes.object,
};

export default MsgDetailModal;
